import View from '../core/View';

export default class DropdownMenuView extends View {

    createView(model) {

        let menuJson = model['menuJson'];
        let visualTemplate = model['visualTemplate'];

        return this.createMenuDropdown(menuJson, visualTemplate);

    }

    createMenuDropdown(menuJson, visualTemplate) {

        let menuDropdown = $('<div>', {
            class: 'dropdown',
            style: 'float: right'
        });

        this.createSearchModal().appendTo(menuDropdown);

        let mainMenuList = this.createMenuList(menuJson, visualTemplate, menuDropdown);

        let menuDropdownBtn = $('<button>', {
            class: 'btn btn-xs btn-default dropdown-toggle',
            css: {
                'background-color': `${visualTemplate.toolbarBackgroundColor}`,
                'color': `${visualTemplate.toolbarTintSecondaryColor}`,
                'border': '0px'
            },
            type: 'button',
            'data-toggle': 'dropdown',
            click: function (e) {
                $('ul.dropdown-menu').css('display', 'none');
                mainMenuList.css('display', '');
            }
        }).appendTo(menuDropdown);

        $('<span>', {
            class: 'glyphicon glyphicon-option-horizontal',
            css: {
                'font-size': '22px',
                'display': 'block'
            }
        }).appendTo(menuDropdownBtn);

        return menuDropdown;
    }

    createMenuList(menuJson, visualTemplate, menuDropdown, backMenuList = undefined) {

        let menuList = $('<ul>', {
            class: 'dropdown-menu dropdown-menu-right',
            css: {
                'background-color': `${visualTemplate.toolbarBackgroundColor}`
            }
        }).appendTo(menuDropdown);

        if (backMenuList != undefined) {

            this.createMenuListElement($('<span>', { class: 'glyphicon glyphicon-menu-left', css: { 'margin-left': '-8px' } }), visualTemplate, function (e) {
                menuList.css('display', 'none');
                backMenuList.css('display', '');
                menuDropdown.addClass('open');
                e.stopPropagation();
            }).appendTo(menuList);

            $('<li>', {
                role: 'separator',
                class: 'divider'
            }).appendTo(menuList);

        }

        for (let key in menuJson) {
            let value = menuJson[key];

            if (typeof value === 'function') {

                this.createMenuListElement(key, visualTemplate, value.bind(this)).appendTo(menuList);

            } else if (typeof value === 'object') {

                let subMenuList = this.createMenuList(value, visualTemplate, menuDropdown, menuList);

                this.createMenuListElement(key, visualTemplate, function (e) {
                    menuList.css('display', 'none');
                    subMenuList.css('display', '');
                    menuDropdown.addClass('open');
                    e.stopPropagation();
                }).appendTo(menuList);

            }

        }

        return menuList;

    }

    createMenuListElement(html, visualTemplate, onClick) {

        let menuListElement = $('<li>', {});

        $('<a>', {
            html: html,
            css: {
                'background-color': `${visualTemplate.toolbarBackgroundColor}`,
                'color': `${visualTemplate.toolbarTintSecondaryColor}`,
                'cursor': 'pointer'
            },
            click: onClick
        }).hover(
            function() { $(this).css("background-color", `${visualTemplate.toolbarTintColor}`); },
            function() { $(this).css("background-color", `${visualTemplate.toolbarBackgroundColor}`); }
        ).appendTo(menuListElement);

        return menuListElement;

    }

    createSearchModal() {
        let textSearch = this.app.polyglot.t("Search");
        let textOK = this.app.polyglot.t("OK");
        let textCancel = this.app.polyglot.t("Cancel");

        let modalFade = $('<div>', {
            id: 'searchModal',
            class: 'modal fade',
            tabindex: '-1',
            role: 'dialog'
        });

        let modalDialog = $('<div>', {
            class: 'modal-dialog modal-sm'
        }).appendTo(modalFade);

        let modalContent = $('<div>', {
            class: 'modal-content'
        }).appendTo(modalDialog);

        let modalHeader = $('<div>', {
            class: 'modal-header'
        }).appendTo(modalContent);

        $('<button>', {
            type: 'button',
            class: 'close',
            'data-dismiss': 'modal',
            html: '<span aria-hidden="true">&times;</span>',
            'aria-label': 'Close'
        }).appendTo(modalHeader);

        $('<h4>', {
            class: 'modal-title',
            text: textSearch
        }).appendTo(modalHeader);

        let modalBody = $('<div>', {
            class: 'modal-body',
            keypress: function(e) {
                if (e.keyCode == $.ui.keyCode.ENTER) {
                    $('#searchButton').trigger("click");
                }
            }
        }).appendTo(modalContent);

        $('<input>', {
            id: 'searchInput',
            type: 'text',
            class: 'form-control'
        }).appendTo(modalBody);

        let modalFooter = $('<div>', {
            class: 'modal-footer'
        }).appendTo(modalContent);

        $('<button>', {
            type: 'button',
            class: 'btn btn-default',
            'data-dismiss': 'modal',
            text: textCancel
        }).appendTo(modalFooter);

        $('<button>', {
            id: 'searchButton',
            type: 'button',
            class: 'btn btn-primary',
            text: textOK,
            click: function(){
                $('#searchModal').on('hidden.bs.modal', function () {
                    let searchString = $('#searchInput').val();
                    this.app.callAction('searchLibraryCatalogs', {
                        'searchString': searchString
                    });
                }.bind(this)).modal('hide');
            }.bind(this)
        }).appendTo(modalFooter);

        return modalFade;
    }

}